<template>
<section>
  <h2 class="instH2">Ответы на вопросы</h2>
  <ul>
    <faqItem v-for="(item,index) in faq" v-bind:key="index" :item="item"></faqItem>
  </ul>
</section>
</template>

<script>
export default {
  name: "faq",
  data(){
    return {
      faq:[
        {
          title:'Кто может получить заём?',
          desc:'<p>Получить микрозайм может любой гражданин РФ от 18 до 70 лет, который проживает <u>в зоне обслуживания</u> нашей компании. Необходимо наличие стабильного источника дохода, из документов нужен только паспорт.</p>'
        },{
          title:'Как быстро проходит оформление?',
          desc:''
        },{
          title:'Как я получу денежные средства?',
          desc:''
        },{
          title:'Дополнительные услуги',
          desc:''
        },{
          title:'Какой срок займа?',
          desc:''
        },{
          title:'Как можно погасить заём?',
          desc:''
        },{
          title:'Что делать, если не успеваю погасить заём?',
          desc:''
        },
      ]
    }
  },
  components:{
    faqItem:() => import('@/components/inst/design/faqItem.vue'),
  }
}
</script>

<style scoped>
  ul{padding: var(--font-size-30) var(--font-size-21);}
  @media screen and (min-width: 760px) {
    ul{display: flex;align-items: flex-start;justify-content: space-between;flex-wrap: wrap;padding: var(--font-size-30) 0;}
  }
</style>